import SidebarItem from '~/client/layout/Sidebar/SidebarItem';

const LiveRtpSidebarItem: FC = () => (
  <SidebarItem
    link="/live-rtp"
    icon="live-rtp"
    text="casino.menu_item.live-rtp"
  />
);

export default LiveRtpSidebarItem;
